import { useContext } from 'react';
import cls from 'clsx';
import { YesNoOptions } from '../../../Common';
import { FormContext, FormLabel } from '../FormElements';
import { TipAlert } from '../../TipAlert';
import { Radio, RadioGroup } from '../Radio';

const defaultOnClick = () => { };

export const YesNoButtons = ({
    name,
    value,
    label = null,
    required = false,
    id = null,
    onClick = defaultOnClick,
    options = YesNoOptions,
    disabled = false,
    TipComponentProps = null,
    className = '',
    ...restProps
}) => {
    const context = useContext(FormContext);

    let fieldValue = value;
    let fieldOnClick = onClick;

    if (context && context.values) {
        fieldValue = context.values[name || id];

        fieldOnClick = (e, v) => {
            onClick(e, v);
            context.onChange(e, v);
        };
    }

    const opts = options.filter(Boolean);

    return (
        <>
            {Boolean(label) && (
                <FormLabel
                    htmlFor={id || name}
                    text={label}
                    required={required}
                    disabled={disabled}
                />
            )}

            {Boolean(TipComponentProps) && (
                <TipAlert
                    {...TipComponentProps}
                />
            )}

            <div
                id={id || name}
                className="d-flex"
                role="radiogroup"
                aria-label={label}
                aria-required={required}
            >
                <RadioGroup
                    {...restProps}
                    name={name}
                    value={fieldValue}
                    required={required}
                    disabled={disabled}
                    onChange={(e) => {
                        let { value } = e.target;

                        if (value === 'true') {
                            value = true;
                        } else if (value === 'false') {
                            value = false;
                        }

                        fieldOnClick(value, { action: 'checkbox', name });
                    }}
                >
                    {opts.map((t, i) => (
                        <Radio
                            key={t.value}
                            value={t.value}
                            label={t.label}
                            className={cls(className, i !== opts.length - 1 && 'mr-2')}
                            {...restProps}
                        />
                    ))}
                </RadioGroup>
            </div>
        </>
    );
};